// apps/share-web/src/theme-boot.ts
//
// Тема применяется НА СТАРТЕ приложения, а не при монтировании читалки, и
// стамп `<html data-theme>` имеет здесь ЕДИНСТВЕННОГО владельца.
//
// Почему это отдельный модуль. До волны E `applyTheme` звали только страница
// слов и текстовая ссылка — тема существовала ровно там, где её выбирали.
// Отсюда B-260915 двумя половинами: (а) выбранная светлая тема не применялась
// при холодном заходе сразу в плеер, (б) стамп, поставленный читалкой,
// оставался на <html> после ухода с неё и красил плеер, где вернуть его было
// нечем. Одно место стампа снимает обе половины: тема принадлежит человеку,
// а не странице.
//
// Почему владелец ОДИН (сквозное ревью волны E). В режиме «Auto» applyTheme
// вешает слушатель системной темы, который сам стампует документ, и гасится
// он только через свой handle. Пока handle держал КАЖДЫЙ потребитель (старт,
// полоса приложения, плеер, страница слов), явный выбор человека гасил лишь
// СВОЙ — чужой слушатель оставался жив и при первом же системном переходе
// перекрашивал экран против выбора: музыкант жмёт «Dark» на светлой сцене, а
// телефон вечером возвращает светлую посреди служения. Поэтому потребители
// зовут `setAppTheme`, а не `applyTheme`: гашение прежнего владельца и
// применение нового — одна операция, и происходит она в одном месте.
import { applyTheme, type ThemeHandle } from './chart/theme.js';
import { loadReaderPrefs, type ReaderTheme } from './chart/reader-prefs.js';
// Значения светлой темы тянет тот, кто объявил себя владельцем стампа.
// Раньше лист приезжал из двух модулей читалки, и держался он на том, что
// main.ts тянет их статически: первый же ленивый импорт читалки вернул бы
// B-260915 в чистом виде — `data-theme="light"` стоит, значений нет.
import './styles/theme-light.css';

let handle: ThemeHandle | null = null;

/**
 * Применить тему ко всему приложению. Гасит прежнего владельца (в «Auto» это
 * слушатель системной темы) и ставит нового. Единственная точка, через
 * которую тему меняет кто угодно — меню аккаунта, плеер, страница слов.
 */
export function setAppTheme(theme: ReaderTheme): void {
  handle?.stop();
  handle = applyTheme(theme);
}

/** Снять сохранённую тему и применить её к документу. Идемпотентно. */
export function applyBootTheme(): void {
  let theme: ReaderTheme = 'dark';
  try {
    theme = loadReaderPrefs().theme;
  } catch {
    // Приватный режим бросает на чтении localStorage. Тёмная — дефолт
    // настроек, и стампуется она ЯВНО: документ без data-theme остался бы
    // тёмным по случайности, а не по решению.
  }
  setAppTheme(theme);
}
